// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  overflow: scroll;
}

.overlay-content {
  background: white;
  padding: 20px 45px 20px 35px;
  border-radius: 8px;
  width: 400px;
  margin-top: 175px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
}

form label {
  display: block;
  margin-bottom: 10px;
}

.instructions {
  font-size: 16px;
  line-height: 18px;
}

form input,
form textarea,
form select {
  padding: 8px;
  margin-top: 5px;
  margin-bottom: 15px;
  border: 1px solid #ccc;
  border-radius: 4px;
}

form input,
form textarea {
  width: 100%;
}

form select {
  width: 105%;
}

.form-buttons {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 10px;
  margin-left: 30px;
}

button {
  padding: 10px 15px;
  width: 180px;
  margin-top: 15px;
  margin-bottom: 15px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  color: white;
  background-color: #3c80d8;
}

button[type="submit"] {
  background-color: #3db432;
  color: white;
  width: 120px;
}

button[type="button"] {
  background-color: #d8352a;
  color: white;
  width: 120px;
}

/* Add styles for the success message */
#success-message {
  text-align: center;
  color: #3db432; /* Green color */
  font-size: 1.5rem;
  font-weight: bold;
}`, "",{"version":3,"sources":["webpack://./src/components/SubscriptionRequest.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,8BAA8B;EAC9B,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,4BAA4B;EAC5B,kBAAkB;EAClB,YAAY;EACZ,iBAAiB;EACjB,wCAAwC;AAC1C;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;;;EAGE,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;;EAEE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;EACT,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;AACd;;AAEA,uCAAuC;AACvC;EACE,kBAAkB;EAClB,cAAc,EAAE,gBAAgB;EAChC,iBAAiB;EACjB,iBAAiB;AACnB","sourcesContent":[".overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: rgba(0, 0, 0, 0.5);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 1000;\n  overflow: scroll;\n}\n\n.overlay-content {\n  background: white;\n  padding: 20px 45px 20px 35px;\n  border-radius: 8px;\n  width: 400px;\n  margin-top: 175px;\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);\n}\n\nform label {\n  display: block;\n  margin-bottom: 10px;\n}\n\n.instructions {\n  font-size: 16px;\n  line-height: 18px;\n}\n\nform input,\nform textarea,\nform select {\n  padding: 8px;\n  margin-top: 5px;\n  margin-bottom: 15px;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n}\n\nform input,\nform textarea {\n  width: 100%;\n}\n\nform select {\n  width: 105%;\n}\n\n.form-buttons {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 10px;\n  margin-left: 30px;\n}\n\nbutton {\n  padding: 10px 15px;\n  width: 180px;\n  margin-top: 15px;\n  margin-bottom: 15px;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n  color: white;\n  background-color: #3c80d8;\n}\n\nbutton[type=\"submit\"] {\n  background-color: #3db432;\n  color: white;\n  width: 120px;\n}\n\nbutton[type=\"button\"] {\n  background-color: #d8352a;\n  color: white;\n  width: 120px;\n}\n\n/* Add styles for the success message */\n#success-message {\n  text-align: center;\n  color: #3db432; /* Green color */\n  font-size: 1.5rem;\n  font-weight: bold;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
